import { render, staticRenderFns } from "./event-page-settings-list-item.vue?vue&type=template&id=c8b6272c&scoped=true&"
import script from "./event-page-settings-list-item.vue?vue&type=script&lang=js&"
export * from "./event-page-settings-list-item.vue?vue&type=script&lang=js&"
import style0 from "./event-page-settings-list-item.vue?vue&type=style&index=0&id=c8b6272c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b6272c",
  null
  
)

export default component.exports